import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import MainContent from '@/components/main-layout/components/main-content/main-content';
import { Box } from '@cmpsr/components';
import React from 'react';

import useAccountController from './account.controller';
import AccountTab from './components/account-tab/account-tab';
import HeroAccount from './components/hero-account/hero-account';

function AccountPage() {
  const {
    name,
    email,
    cardLast4Digits,
    assessmentProgress,
    type,
    cancelAtPeriodEnd,
    usdPrice,
    renewalDate,
    questionnaireStatus,
    iDontKnowAnswers,
    answeredQuestions,
    notificationsPreferences,
    paymentFunding,
    isVipAccess,
    subscriptionStatus,
  } = useAccountController();

  return (
    <>
      <DashboardNavigationBar />
      <MainContent data-testid="account-page">
        <HeroAccount username={name} />
        <Box
          px={{
            base: 'spacer-4',
            md: 'spacer-8',
            lg: 'spacer-16',
            xl: 'spacer-24',
            xxl: 'spacer-32',
          }}
          maxWidth="1440px"
          marginX="auto"
        >
          <AccountTab
            name={name}
            email={email}
            type={type}
            usdPrice={usdPrice}
            renewalDate={renewalDate}
            assessmentProgress={assessmentProgress}
            cancelAtPeriodEnd={cancelAtPeriodEnd}
            questionnaireStatus={questionnaireStatus}
            iDontKnowAnswers={iDontKnowAnswers}
            totalAnsweredQuestions={answeredQuestions}
            notificationsPreferences={notificationsPreferences}
            cardLast4Digits={cardLast4Digits}
            paymentFunding={paymentFunding}
            isVipAccess={isVipAccess}
            subscriptionStatus={subscriptionStatus}
          />
        </Box>
      </MainContent>
    </>
  );
}

export default React.memo(AccountPage);
